import { useAtomValue } from 'jotai';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { tokens } from 'smoothie';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { userFullNameAtom } from '../../user/state/UserAtoms';
import type { InlineCalendlyWidgetProps } from '../types/GuidanceSessions';

const InlineCalendlyWidget = ({
    calendlyUrl,
    onEventScheduled,
    containerHeight,
}: InlineCalendlyWidgetProps) => {
    const { email, id } = useAuthedUser();
    const name = useAtomValue(userFullNameAtom);

    const brandColor = tokens.color.light.green.green1100.split('#')[1];

    useCalendlyEventListener({
        onEventScheduled,
    });

    return (
        <InlineWidget
            url={calendlyUrl}
            prefill={{ email, name }}
            utm={{
                utmContent: id,
            }}
            pageSettings={{
                hideEventTypeDetails: false,
                hideLandingPageDetails: true,
                hideGdprBanner: true,
                // Settings below here only effective with pro account
                backgroundColor: 'ffffff',
                primaryColor: brandColor,
                textColor: '000000',
            }}
            styles={{
                height: containerHeight ?? '80vh',
            }}
        />
    );
};

export default InlineCalendlyWidget;
